export const THEME_ASSETS_URL = vizacademy_config.theme_assets;
export const THEME_URL = THEME_ASSETS_URL.substr(0, THEME_ASSETS_URL.lastIndexOf('/'));

export const SUPPORTED_PAGES = {
  'page-template-welcome': () => import( /* webpackChunkName: "page-template-welcome" */ './page-template-welcome'),
}